class AbstractPasswordValidator {
    validate(password) {
        throw 'AbstractPasswordValidator.validate() must be overridden.';
    }
}

export default AbstractPasswordValidator;